import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { Box, Typography, CircularProgress, Paper } from '@mui/material';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import analyticsService from '../services/analyticsService';

// Registrar los componentes necesarios de Chart.js
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const ClientsByHourChart = ({ filters }) => {
  const [loading, setLoading] = useState(true);
  const [clientsData, setClientsData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await analyticsService.getClientsByHour(filters);
        // Ordenar los datos por hora (0-23)
        const sortedData = data.sort((a, b) => a.hour - b.hour);
        setClientsData(sortedData);
        setError(null);
      } catch (err) {
        console.error('Error al obtener datos de clientes por hora:', err);
        setError('No se pudieron cargar los datos de clientes por hora');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [filters]);

  const chartData = {
    labels: clientsData.map(item => item.hour_display),
    datasets: [
      {
        label: 'Promedio de clientes por hora',
        data: clientsData.map(item => item.average_clients),
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
        tension: 0.1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Afluencia de Clientes por Hora del Día',
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Hora del día'
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Promedio de Clientes'
        }
      }
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" gutterBottom>
        Afluencia de Clientes por Hora
      </Typography>
      <Box sx={{ height: 400, position: 'relative' }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Typography color="error">{error}</Typography>
          </Box>
        ) : clientsData.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Typography>No hay datos disponibles para el período seleccionado</Typography>
          </Box>
        ) : (
          <Line data={chartData} options={options} />
        )}
      </Box>
    </Paper>
  );
};

export default ClientsByHourChart;
